import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(
    private toastController: ToastController,
  ) {}

  async showSuccess(summary: string, detail: string, duration?: number, position?: 'top' | 'bottom' | 'middle'): Promise<void> {
    await this.showToast(summary, detail, 'success', duration, position);
  }

  async showError(summary: string, detail: string, duration?: number, position?: 'top' | 'bottom' | 'middle'): Promise<void> {
    await this.showToast(summary, detail, 'danger', duration, position);
  }

  async showInfo(summary: string, detail: string, duration?: number, position?: 'top' | 'bottom' | 'middle'): Promise<void> {
    await this.showToast(summary, detail, 'primary', duration, position);
  }

  async showWarn(summary: string, detail: string, duration?: number, position?: 'top' | 'bottom' | 'middle'): Promise<void> {
    await this.showToast(summary, detail, 'warning', duration, position);
  }

  private async showToast(
    header: string,
    message: string,
    color: string,
    duration?: number,
    position?: 'top' | 'bottom' | 'middle'
  ): Promise<void> {
    const toast = await this.toastController.create({
      header: header,
      message: message,
      duration: duration || 3000,
      position: position || 'bottom',
      color: color,
    });
    await toast.present();
  }
}
